module.exports = __webpack_public_path__ + "img/launch.662484af.jpg";